var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "nonzero",
    d: "M7.098 4.623h1.29v1.321h-1.29v-1.32zm0 2.642h1.29v3.963h-1.29V7.265zm.646-5.944c-3.562 0-6.453 2.959-6.453 6.605 0 3.646 2.89 6.605 6.453 6.605 3.562 0 6.453-2.96 6.453-6.605 0-3.646-2.891-6.605-6.453-6.605zm0 11.889c-2.846 0-5.163-2.371-5.163-5.284s2.317-5.284 5.163-5.284c2.845 0 5.162 2.371 5.162 5.284s-2.317 5.284-5.162 5.284z",
    transform: "translate(.606 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.487V15.852H0z",
    transform: "translate(.606 .667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.487V15.852H0z",
    transform: "translate(.606 .667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfowhite);
export default __webpack_public_path__ + "static/media/infowhite.99e820ed7fd9152d063a9ab6c2c78165.svg";
export { ForwardRef as ReactComponent };